import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const headCells = [
  {
    id: "no",
    numeric: false,
    disablePadding: false,
    label: "NO",
  },
  {
    id: "nama",
    numeric: false,
    disablePadding: false,
    label: "Nama Entitas",
  },
  {
    id: "masuk",
    numeric: false,
    disablePadding: false,
    label: "Jam Masuk",
  },
  {
    id: "pulang",
    numeric: false,
    disablePadding: false,
    label: "Jam Pulang",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
  },
];

const EnhancedTableHead = (props) => {
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default EnhancedTableHead;
